import React from 'react';
import { RoutePath, UserRole } from 'types/enums';

import { SidebarItemType } from '../types/sidebar-item.type';
import { SidebarTitle } from '../types/sidebar-title.enum';

import { UserRoleType } from 'types/types';
import {
  HospitalLogo,
  HomeOutlinedIcon,
  PeopleOutlinedIcon,
  PersonOutlinedIcon,
  MonitorHeart,
  CableIcon,
  QueryBuilderIcon,
  FavoriteBorderIcon,
} from 'assets/sidebar/icons';

type ConstantGroup = (Omit<SidebarItemType, 'selected' | 'setSelected'> & { roleAllowed?: UserRoleType[] })[];

const SIDEBAR_TOP_GROUP: ConstantGroup = [
  {
    title: SidebarTitle.MY_PRACTICE,
    to: RoutePath.PRACTICE,
    icon: <HospitalLogo width={25} />,
    roleAllowed: [UserRole.PATIENT, UserRole.CAREGIVER, UserRole.ADMIN],
  },
  {
    roleAllowed: [UserRole.CAREGIVER, UserRole.ADMIN],
    title: SidebarTitle.PATIENTS,
    to: RoutePath.PATIENTS,
    icon: <PeopleOutlinedIcon />,
  },
  { title: SidebarTitle.ECGS, to: RoutePath.ECG, icon: <MonitorHeart /> },
  {
    title: SidebarTitle.PPG,
    to: RoutePath.PPG,
    icon: <FavoriteBorderIcon />,
    roleAllowed: [UserRole.PATIENT, UserRole.CAREGIVER, UserRole.ADMIN],
  },
  {
    title: SidebarTitle.STUDY_ANALYSIS,
    to: RoutePath.STUDY,
    icon: <HomeOutlinedIcon />,
    roleAllowed: [UserRole.PATIENT, UserRole.CAREGIVER, UserRole.ADMIN],
  },
];

const PARTNER_SIDEBAR_TOP_GROUP: ConstantGroup = [
  {
    title: SidebarTitle.ECGS,
    to: RoutePath.ECG,
    icon: <MonitorHeart />,
    roleAllowed: [UserRole.PARTNER],
  },
  {
    title: SidebarTitle.PARTNER_CONNECT,
    to: RoutePath.PARTNER_CONNECT,
    icon: <CableIcon />,
    roleAllowed: [UserRole.PARTNER],
  },
];

const SIDEBAR_MIDDLE_GROUP: ConstantGroup = [
  // {
  //   title: SidebarTitle.ECG_ANALYZE,
  //   to: RoutePath.ECG_ANALYZE,
  //   icon: <MonitorHeart />,
  //   roleAllowed: [
  //     UserRole.CAREGIVER,
  //     UserRole.FACILITY_ADMIN,
  //     UserRole.ADMIN,
  //     UserRole.MULTI_FACILITY_ADMIN,
  //     UserRole.MULTI_FACILITY_CAREGIVER,
  //   ],
  // },
  {
    title: SidebarTitle.PROFILE_FORM,
    to: RoutePath.PATIENT_DETAIL,
    icon: <PersonOutlinedIcon />,
    roleAllowed: [UserRole.PATIENT, UserRole.CAREGIVER, UserRole.ADMIN],
  },
  {
    title: SidebarTitle.REGISTER_ADMIN,
    to: RoutePath.ADMIN,
    icon: <PeopleOutlinedIcon />,
    roleAllowed: [UserRole.ADMIN],
  },
  {
    title: SidebarTitle.CONNECT_FACILITY,
    to: RoutePath.CONNECT_FACILITY,
    icon: <CableIcon />,
    roleAllowed: [UserRole.PATIENT, UserRole.CAREGIVER, UserRole.ADMIN],
  },
  {
    title: SidebarTitle.CONNECT_PATIENT,
    to: RoutePath.CONNECT_PATIENT,
    icon: <CableIcon />,
    roleAllowed: [UserRole.CAREGIVER],
  },
  {
    title: SidebarTitle.REQUESTS,
    to: RoutePath.REQUESTS,
    icon: <QueryBuilderIcon />,
    roleAllowed: [UserRole.ADMIN],
  },
];

export { SIDEBAR_TOP_GROUP, SIDEBAR_MIDDLE_GROUP, PARTNER_SIDEBAR_TOP_GROUP };
